import { render, staticRenderFns } from "./NewsProgram.vue?vue&type=template&id=002a62c4&"
import script from "./NewsProgram.vue?vue&type=script&lang=js&"
export * from "./NewsProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports